export const ViewAttendanceType = {
    GET_VIEW_ATTENDANCE_DATA: "GET_VIEW_ATTENDANCE_DATA",
    SET_VIEW_ATTENDANCE_DATA: "SET_VIEW_ATTENDANCE_DATA",
    GET_LEAVE_DETAILS: "GET_LEAVE_DETAILS",
    SET_LEAVE_DETAILS: "SET_LEAVE_DETAILS",
    GET_ATTENDANCE_FOR_EXCEL: "GET_ATTENDANCE_FOR_EXCEL",
    SET_ATTENDANCE_FOR_EXCEL: "SET_ATTENDANCE_FOR_EXCEL",
    SUBMIT_ATTENDANCE_CORRECTION: "SUBMIT_ATTENDANCE_REGULARIZATION",
    SET_ATTENDANCE_CORRECTION_SUCCESS: "SET_ATTENDANCE_REGULARIZATION_SUCCESS",
    SET_ATTENDANCE_CORRECTION_ERROR: "SET_ATTENDANCE_REGULARIZATION_ERROR",
    INSERT_MISSING_ATTENDANCE: "INSERT_MISSING_ATTENDANCE",
    SET_MISSING_ATTENDANCE_SUCCESS: "SET_MISSING_ATTENDANCE_SUCCESS",
    SET_MISSING_ATTENDANCE_ERROR: "SET_MISSING_ATTENDANCE_ERROR"
}

export const getViewAttendanceData = (data) => 
({
  type: ViewAttendanceType.GET_VIEW_ATTENDANCE_DATA,
  payload: data,
});

export const setViewAttendanceData = (data) =>
({
    type: ViewAttendanceType.SET_VIEW_ATTENDANCE_DATA,
    payload:data,
})

export const getLeaveDetails = (data) =>
({
    type: ViewAttendanceType.GET_LEAVE_DETAILS,
    payload:data,
})

export const setLeaveDetails = (data) =>
({
    type: ViewAttendanceType.SET_LEAVE_DETAILS,
    payload:data,
})
export const getAttendanceForExcel = (data) =>
({
    type: ViewAttendanceType.GET_ATTENDANCE_FOR_EXCEL,
    payload:data,
})

export const setAttendanceForExcel = (data) =>
({
    type: ViewAttendanceType.SET_ATTENDANCE_FOR_EXCEL,
    payload:data,
})

export const submitAttendanceCorrection = (data) =>
({
    type: ViewAttendanceType.SUBMIT_ATTENDANCE_CORRECTION,
    payload:data,
})

export const setAttendanceCorrectionSuccess = (data) =>
({
    type: ViewAttendanceType.SET_ATTENDANCE_CORRECTION_SUCCESS,
    payload:data,
})

export const setAttendanceCorrectionError = (data) =>
({
    type: ViewAttendanceType.SET_ATTENDANCE_CORRECTION_ERROR,
    payload:data,
});

export const setMissingAttendanceSuccess = (data) =>
({
    type: ViewAttendanceType.SET_MISSING_ATTENDANCE_SUCCESS,
    payload:data,
});

export const setMissingAttendanceError = (data) =>
({
    type: ViewAttendanceType.SET_MISSING_ATTENDANCE_ERROR,
    payload:data,
});